import { PayloadAction } from '@reduxjs/toolkit';
import {
  ActivateRiskProfileRequest,
  RiskProfileResponse,
  amlbotAPI,
  BaseRequest,
  BaseSuccessResponse,
  CreateRiskProfileRequest,
  GetRiskProfilesResponse,
  RiskProfileUpdateSignalsRequest,
  BaseRiskProfileRequest,
  RiskProfileUpdateRequest,
} from '@/api';
import { SagaIterator } from '@/redux-saga';
import { call, put } from 'redux-saga/effects';
import { riskscoreProfilesActions } from '@/redux/actions';
import { riskscoreProfilesMappers } from '@/redux/mappers';

function* listRiskProfiles(action: PayloadAction<BaseRequest>): SagaIterator {
  try {
    const payload: BaseRequest = {};

    const response: GetRiskProfilesResponse = yield call(
      amlbotAPI.listRiskProfiles,
      payload,
    );

    const data = riskscoreProfilesMappers.listRiskProfiles(response);
    yield put(riskscoreProfilesActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setLoading(false));
  }
}

function* createRiskProfile(
  action: PayloadAction<CreateRiskProfileRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: BaseSuccessResponse = yield call(
      amlbotAPI.createRiskProfile,
      payload,
    );
    yield put(riskscoreProfilesActions.listRiskProfiles({}));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setLoading(false));
  }
}

function* activateRiskProfile(
  action: PayloadAction<ActivateRiskProfileRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: RiskProfileResponse = yield call(
      amlbotAPI.activateRiskProfile,
      payload,
    );

    const data = riskscoreProfilesMappers.riskProfile(response);
    yield put(riskscoreProfilesActions.updateProfileState(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setLoading(false));
  }
}

function* setProfileSignals(
  action: PayloadAction<RiskProfileUpdateSignalsRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const { profileId } = payload;
    const response: RiskProfileResponse = yield call(
      amlbotAPI.setProfileSignals,
      payload,
    );
    yield put(riskscoreProfilesActions.fetchRiskProfile({ profileId }));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setProfileLoading(false));
  }
}

function* fetchRiskProfile(
  action: PayloadAction<BaseRiskProfileRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: RiskProfileResponse = yield call(
      amlbotAPI.fetchRiskProfile,
      payload,
    );

    const data = riskscoreProfilesMappers.riskProfile(response);
    yield put(riskscoreProfilesActions.updateProfileState(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setProfileLoading(false));
  }
}

function* resetRiskProfile(
  action: PayloadAction<BaseRiskProfileRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const { profileId } = payload;

    const response: RiskProfileResponse = yield call(
      amlbotAPI.resetRiskProfile,
      payload,
    );

    yield put(riskscoreProfilesActions.fetchRiskProfile({ profileId }));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setProfileLoading(false));
  }
}

function* deleteRiskProfile(
  action: PayloadAction<BaseRiskProfileRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const { profileId } = payload;

    const response: RiskProfileResponse = yield call(
      amlbotAPI.deleteRiskProfile,
      payload,
    );

    yield put(riskscoreProfilesActions.listRiskProfiles({}));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setProfileLoading(false));
  }
}

function* updateRiskProfile(
  action: PayloadAction<RiskProfileUpdateRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const { profileId } = payload;
    const response: RiskProfileResponse = yield call(
      amlbotAPI.updateRiskProfile,
      payload,
    );
    yield put(riskscoreProfilesActions.fetchRiskProfile({ profileId }));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(riskscoreProfilesActions.setProfileLoading(false));
  }
}

export {
  listRiskProfiles,
  createRiskProfile,
  activateRiskProfile,
  setProfileSignals,
  fetchRiskProfile,
  resetRiskProfile,
  deleteRiskProfile,
  updateRiskProfile,
};
